<template>
  <div class="w-full max-w-4xl mx-auto mb-8">
    <!-- Progress Line -->
    <div class="relative">
      <!-- Background Line -->
      <div class="w-full h-2 bg-gray-200 rounded-full"></div>

      <!-- Progress Line -->
      <div
        class="absolute top-0 left-0 h-2 bg-primary rounded-full transition-all duration-500 ease-out"
        :style="{ width: `${getProgressPercentage()}%` }"
      ></div>
    </div>

    <!-- Progress Text -->
    <div class="flex items-center justify-between mt-4">
      <div class="text-sm font-medium text-gray-600">
        Step {{ currentStep }} of {{ totalSteps }}
      </div>
      <div class="text-sm font-medium text-gray-600">
        {{ Math.round(getProgressPercentage()) }}%
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingProgressBar',

  props: {
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      default: 3
    }
  },

  methods: {
    getProgressPercentage() {
      return (this.currentStep / this.totalSteps) * 100
    }
  }
}
</script>
